import instance from '@/services/repository';

const resource = '/machineries';

export default {
    lookup(options: any, profileId?: string, onlyAvailable?: boolean) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        if (!onlyAvailable) {
            onlyAvailable = false;
        }

        let query = `?onlyAvailable=${onlyAvailable}`;
        if (profileId) {
            query += '&profileId=' + profileId;
        }

        return instance
            .post(`${resource}/lookup${query}`,
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data' },
                });
    },
    getSingle(id: string) {
        return instance.get<IMachinery>(`${resource}/${id}`);
    },
    create(payload: IMachineryCreateCommand) {
        return instance.post<IMachinery>(`${resource}`, payload);
    },
    update(payload: IMachineryUpdateCommand) {
        return instance.put<IMachinery>(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    /*addOrUpdateEvent(id: string, payload: any) {
        return instance.post<IMachinery>(`${resource}/${id}/Event`, payload);
    },
    deleteEvent(id: string, eventId: number) {
        return instance.delete(`${resource}/${id}/Event/${eventId}`);
    },*/
};
